import {upperFirst} from 'lodash';
import {createSlice, Draft} from '@reduxjs/toolkit';

export const buildGeneralBooleanSlice = (
    name: string,
    defaultValue = false
) => {
    const slice = createSlice({
        name,
        initialState: defaultValue,
        reducers: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            makeTrue: state => (state = true),
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            makeFalse: state => (state = false),
            toggle: state => (state = !state),
        },
    });
    return slice;
};

export const buildGeneralSetState =
    (name: string) => (state: any, action: {type: string; payload: any}) => ({
        ...state,
        [name]: action.payload,
    });

export const buildGeneralToggleState = (name: string) => (state: any) => ({
    ...state,
    [name]: !state[name],
});

export const buildGeneralResetState =
    (name: string, initialState: any) => (state: any) => ({
        ...state,
        [name]: initialState,
    });

// We shouldn't mutate the state, but if the object is too large it might be a performance issue
// export const buildGeneralSetState =
//     (name: string) => (state: any, action: {type: string; payload: any}) => {
//         state[name] = action.payload;
//         return state;
//     };

// export const buildGeneralToggleState = (name: string) => (state: any) => {
//     state[name] = !state[name];
//     return state;
// };

// export const buildGeneralResetState =
//     (name: string, initialState: any) => (state: any) => {
//         state[name] = initialState;
//         return state;
//     };

export const buildGeneralPlainState = <T>(name: string, initialState?: any) => {
    const setName = `set${upperFirst(name)}`;
    const resetName = `reset${upperFirst(name)}`;
    return {
        [setName]: (state: Draft<T>, action: {type: string; payload: any}) => ({
            ...state,
            [name]: action.payload,
        }),
        // [resetName]: (state: Draft<T>, action: {type: string; payload: any}) => ({
        [resetName]: (state: Draft<T>) => ({
            ...state,
            [name]: initialState,
        }),
    };
};

export const buildGeneralBooleanState = (
    name: string,
    initialState = false,
    postfix = ''
) => {
    const setName = `set${upperFirst(name)}${postfix}`;
    const resetName = `reset${upperFirst(name)}${postfix}`;
    const toggleName = `toggle${upperFirst(name)}${postfix}`;
    return {
        [setName]: (state: any, action: {type: string; payload: boolean}) => {
            state[name] = action.payload;
            return state;
        },
        [resetName]: (state: any) => {
            state[name] = initialState;
            return state;
        },
        [toggleName]: (state: any) => {
            state[name] = !state[name];
            return state;
        },
    };
};
